import { A } from "@solidjs/router";
import { Show, Component, onMount } from "solid-js";
import { Img } from "./universal/image";
import { UserSession, AtelierImage, ImageType } from "../types";
import { createStore } from "solid-js/store";
import { getPlainText, loadCms } from "../app";

type Props = {
    session: UserSession;
    atelierImage: AtelierImage;
    resources: {
        canApply: boolean;
    };
    deleteClicked: (id: string) => void;
};

type State = {
    isContentReady: boolean;
}
export const AtelierImageItem : Component<Props> = (props) => {
    const canApply: boolean = props.resources.canApply;
    const [state, setState] = createStore<State>({ isContentReady: false });
    const [data, setData] = createStore<AtelierImage>(props.atelierImage);
    const deleteAtelierImageClicked = (atelierImage: AtelierImage) =>{
        console.log("deleteAtelierImageClicked", { facultyMember: atelierImage });
        if (confirm(getPlainText("dialog::sure-you-wish-to-delete-this-entry", "Are you sure you wish to delete this entry?"))) {
            props.deleteClicked(atelierImage.Id);
        }
    };
    const it = props.atelierImage.ImageType;
    const action = it == ImageType.InstructorWork ? "edit-instructor-work" : it == ImageType.StudentWork ? "edit-student-work" : "edit-other-image";
    const url = `/${action}/${data.Id}`;
    onMount(async () => {
        const ids=[
            "label::medium","label::purchase-award-nominated-price","label::size","label::completed-in","label::location","label::about-this-artwork",
            "label::categories","label::images",
            "salon-application/step-2::salon-artwork/file-details",
            "button::view","button::edit","button::delete","button::add",
            "button::remove",
            "error::category/unable-to-enter","error::category/select-from-list",
            "dialog::sure-you-wish-to-delete-this-image","dialog::sure-you-wish-to-delete-this-entry",
            "error::category/unable-to-remove-artwork","error::category/unable-to-enter"
        ];
        await loadCms(ids);
        setState("isContentReady", true);
    });
    return (
        <div class="artwork-container" style="padding: 10px 20px;">
            <h3>
                {data.NewImage.Name}
            </h3>
            <div style="background-color: #000; color: #fff; padding: 10px;">
                <A href={url}><Img src={ data.NewImage.URL } mode="crop" width={300} format="jpg" style="width: 100%;" /></A>
            </div>
            <Show when={canApply}>
                <div style="margin-top: 20px;">
                    <A class="btn btn-primary" style="margin-right: 5px;" href={url}>Edit</A>
                    <button class="btn btn-danger" onClick={(e) => { e.preventDefault(); deleteAtelierImageClicked(data); }}>Delete</button>
                </div>
            </Show>
        </div>
    );
}